import { render } from "./SearchFormPublic.vue?vue&type=template&id=22ad86b4"
import script from "./SearchFormPublic.vue?vue&type=script&lang=js"
export * from "./SearchFormPublic.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__